import { render, staticRenderFns } from "./DraftListEditB3.vue?vue&type=template&id=25792971"
import script from "./DraftListEditB3.vue?vue&type=script&lang=js"
export * from "./DraftListEditB3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports